import { withUrl, Request, get, ItemRequest } from '@factorin/rest';
import { Pagination } from '@factorin/domain';


interface ImgSettings {
    file: {
        url: string;
    };
    width: number;
    height: number;
}

export interface WithUsPaginationElement {
    id: string;
    name?: string;
    link?: string;
    small: ImgSettings;
    big: ImgSettings;
}

type WithUsIds = Array<string>;

export const WITH_US_DOMAIN_PATH = 'withUs';
const withUsPart = withUrl('WithUs');
export const withUs = {
    itemList: get<void, WithUsIds>(() => withUsPart()),
    item: get<ItemRequest, WithUsPaginationElement>(({ id }) => withUsPart({ path: `${id}` })),
    list: get<Request.Query<Pagination.Request>, WithUsPaginationElement>(
        ({ query }) => withUsPart({
            path: 'list',
            ...query,
        }),
    ),
};
